import styled from 'styled-components';
import { Box } from '../../CommonComponents/OPL/Box/Box';

export const ExpensesGrid = styled(Box)({
  display: 'grid',
  gridTemplateAreas: `
    'header actions'
    'content content'
  `,
  gridTemplateColumns: '1fr auto',
  alignItems: 'end',
});
